import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, watch } from 'vue';

  //eslint-disable-next-line
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppInputSelectRow',
  props: {
    text: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    showSelectCircle: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

  

  const { text, isSelected, showSelectCircle } = toRefs(props);

  const timerToHoverClass = ref(false);

  watch(isSelected, () => {
    if (isSelected.value) {
      timerToHoverClass.value = true;
      setTimeout(() => {
        timerToHoverClass.value = false;
      }, 600);
    }
  });

const __returned__ = { props, text, isSelected, showSelectCircle, timerToHoverClass, ref, toRefs, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})